"use strict";

// We support variant switching using either a select, or a series of
// buttons/anchors for "basic" switching; and using multiple series of
// buttons/anchors for "product-attribute-based" switching

let productAttributeMap = null;

function getVariantIDFromUrlFragment() {
    const urlFragment = $('.js-product-variant-switcher').data('url-fragment-prefix');
    let variantHashPrefix = '#';
    if (urlFragment !== undefined) variantHashPrefix += urlFragment;
    if (variantHashPrefix === "#") variantHashPrefix = ""
    let variantID = null;
    if (window.location.hash.indexOf(variantHashPrefix) === 0) {
        variantID = window.location.hash.substring(variantHashPrefix.length);
    }
    return variantID
}

function getSelectedVariantID() {
    let selectedVariantID = null;

    // Get the product attributes of the selected switchers
    let selectedProductAttributes = {}
    $('.js-variant-switcher-product-attribute-based.active').each(function() {
        selectedProductAttributes[$(this).data('variant-product-attribute-code')] = $(this).data('variant-product-attribute-value').toString();
    });

    // Get the variant matching the selected product attributes
    $.each(productAttributeMap, function(variantID, productAttributes) {
        let numOfSelectedAttributesInMap = 0;
        $.each(selectedProductAttributes, function(code, value) {
            if (productAttributes[code] === value) {
                numOfSelectedAttributesInMap += 1;
            }
        });
        if ((numOfSelectedAttributesInMap === Object.keys(productAttributes).length) && (numOfSelectedAttributesInMap === Object.keys(selectedProductAttributes).length)) {
            selectedVariantID = variantID;
            // Break from the loop upon the first found variant ID matching the
            // selected attributes, as only one variant should match a
            // particular combination of product attributes
            return false;
        }
    });

    return selectedVariantID;
}

function displayToastMessage($selectedSwitcher) {
    const $switchersToast = $($('.js-variant-switchers-toast-markup').html());
    $('#toast-container').append($switchersToast);
    $switchersToast.toast('show');
}

function toggleAddToCartButton(enable) {
    const variantID = getVariantIDFromUrlFragment();
    if (variantID !== null) {
        $(`.js-product-variants__variant[data-id="${variantID}"] .js-add-to-cart-button`).prop("disabled", enable !== true);
    }
}

function selectSwitchers(variantID) {
    const attributes = productAttributeMap[variantID];
    $.each(attributes, function(code, value) {
        $(`.js-variant-switcher-product-attribute-based[data-variant-product-attribute-code="${code}"][data-variant-product-attribute-value="${value.replace('"', "quote")}"]`).addClass('active').siblings().removeClass('active');
    });
}

function showVariant(variantID) {
    const variantFragmentPrefix = $('.js-product-variant-switcher').data('url-fragment-prefix');
    let url = `#`;
    if (variantFragmentPrefix !== undefined) url += variantFragmentPrefix;
    if (variantID !== undefined) url += variantID;
    if (url === "#") url = "";
    history.replaceState(null, '', url);
    $('.js-product-variants__variant').addClass('d-none')
        .filter(`[data-id="${variantID}"]`).removeClass('d-none');
    // Force the thumbnail slider for the gallery to reload
    $('.catalogue-gallery-thumbnails-switcher').sly('reload');
}

function showHintsForUnavailableVariants($currentSelectedSwitcher) {
    const $allSwitchers = $('.js-variant-switcher-product-attribute-based');
    $allSwitchers.addClass('unavailable');

    // Switchers from series of the currently-selected switcher
    const $currentSeriesSwitchers = $currentSelectedSwitcher.parent().children();
    // Switchers from series other than the series of the currently-selected
    // switcher
    const $otherSeriesSwitchers = $allSwitchers.not($currentSeriesSwitchers);

    // Unmark switchers for available variants
    const currentSelectedProductAttributeCode = $currentSelectedSwitcher.data('variant-product-attribute-code');
    const currentSelectedProductAttributeValue = $currentSelectedSwitcher.data('variant-product-attribute-value').toString();
    $.each(productAttributeMap, function(variantID, productAttributes) {
        // Switchers from "current" series
        let productAttributesMatchOtherSelectedSwitchers = true;
        const $otherSelectedSwitchers = $otherSeriesSwitchers.filter('.active');
        $otherSelectedSwitchers.each(function() {
            const $otherSelectedSwitcher = $(this);
            const otherSelectedProductAttributeCode = $otherSelectedSwitcher.data('variant-product-attribute-code');
            const otherSelectedProductAttributeValue = $otherSelectedSwitcher.data('variant-product-attribute-value').toString();
            if (!(otherSelectedProductAttributeCode in productAttributes) || (productAttributes[otherSelectedProductAttributeCode] !== otherSelectedProductAttributeValue)) {
                productAttributesMatchOtherSelectedSwitchers = false;
                // Break from the loop
                return false;
            }
        });
        if (productAttributesMatchOtherSelectedSwitchers) {
            const availableSelector = `[data-variant-product-attribute-code="${currentSelectedProductAttributeCode}"][data-variant-product-attribute-value="${productAttributes[currentSelectedProductAttributeCode]}"]`;
            $currentSeriesSwitchers.filter(availableSelector).removeClass('unavailable');
        }

        // Switchers from "other" series
        if ((currentSelectedProductAttributeCode in productAttributes) && (productAttributes[currentSelectedProductAttributeCode] === currentSelectedProductAttributeValue)) {
            const availableSelector = $.map(productAttributes, function(value, code) {
                 return `[data-variant-product-attribute-code="${code}"][data-variant-product-attribute-value="${value.replace('"', "quote")}"]`;
            }).join(', ');
            $otherSeriesSwitchers.filter(availableSelector).removeClass('unavailable');
        }
    });
}

$(function() {
    $('select.js-variant-switcher').on('change', function(e){
        showVariant($(this).val());
    });

    $('a.js-variant-switcher, button.js-variant-switcher').on('click', function(e){
        e.preventDefault();
        $(this).addClass('active').siblings().removeClass('active');
        showVariant($(this).data('id'));
    });

    $('.js-variant-switcher-product-attribute-based').on('click', function(e) {
        e.preventDefault();
        $(this).addClass('active').siblings().removeClass('active');
        let variantID = getSelectedVariantID();
        if (variantID === null) {
            displayToastMessage($(this));
            toggleAddToCartButton(false);
        } else {
            showVariant(variantID);
            toggleAddToCartButton(true);
        }
        showHintsForUnavailableVariants($(this));
    });

    let variantID = getVariantIDFromUrlFragment();
    const variantProductAttributeValuesMapEl = document.getElementById('variant-product-attribute-values-map');
    if (variantProductAttributeValuesMapEl === null) {
        // We are using "basic" switching
        if (variantID === null) {
            // Use the first variant ID in the select, or the series of
            // buttons/anchors
            const $selectSwitcherOptions = $('select.js-variant-switcher option');
            if ($selectSwitcherOptions.length) {
                variantID = $selectSwitcherOptions.val();
            }
            const $anchorOrButtonSwitchers = $('a.js-variant-switcher, button.js-variant-switcher');
            if ($anchorOrButtonSwitchers.length) {
                variantID = $anchorOrButtonSwitchers.data('id');
            }
        }
        // Select
        $('select.js-variant-switcher').val(variantID).change();
        // Button/anchor
        $(`.js-variant-switcher[data-id="${variantID}"]`).click();
    } else {
        // We are using "product-attribute-based" switching
        productAttributeMap = JSON.parse(variantProductAttributeValuesMapEl.textContent);
        if ((variantID === null) || !(variantID in productAttributeMap)) {
            // Use the first variant ID in the map
            variantID = Object.keys(productAttributeMap)[0];
        }
        selectSwitchers(variantID);
        showVariant(variantID);
    }
});
